import React, { useEffect, useState } from "react";
import { CloseOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Modal, message } from "antd";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import StyledCoursePage from "./style";
import { useSelector } from "react-redux";
import PostUpdateData from "../../../../hooks/postUpdate";
const { Option } = Select;

const EditCourseField = ({
  setCourseView,
  selectedData = {},
  courseView,
  handleGetCourseData,
}) => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [formValues, setFormValues] = useState({});
  const [selectedType, setSelectedType] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [newOptionText, setNewOptionText] = useState("");
  const isEditMode = !!selectedData;
  const userInfo = useSelector((state) => state.authTracking.userInfo);

  const handleCancel = () => {
    setCourseView("course");
  };

  const handlePostData = async () => {
    if (formValues.type === "dropdown" && dropdownOptions.length === 0) {
      message.error("Please add at least one dropdown option");
      return;
    }
    const payload = {
      course_name: formValues.course_name,
      type: formValues.type,
      mandatory: formValues.mandatory === "yes" ? true : false,
      visible_to_learn: formValues.visible_to_learn === "yes" ? true : false,
      visible_on_report: formValues.visible_on_report === "yes" ? true : false,
      field_options:
        formValues.type === "dropdown"
          ? JSON.stringify(dropdownOptions)
          : null,
      updated_at: new Date().toISOString(),
    };

    try {
      const response = await PostUpdateData({
        endPoint: `/settings/addcourse/${userInfo.clientId}`,
        method: "POST",
        obj: payload,
      });
      if (response?.statusCode === 200 || response?.statusCode === 201) {
        setModalMessage("Created");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
          setCourseView("course");
          // form.resetFields();
        }, 2000);
        handleGetCourseData();
      } else {
        setModalMessage("Error occurred");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error while saving custom field:", error);
      setModalMessage("Error occurred");
      setIsModalVisible(true); // Show error modal
      setTimeout(() => {
        setIsModalVisible(false);
      }, 2000);
    }
  };

  const handlePatchData = async () => {
    if (formValues.type === "dropdown" && dropdownOptions.length === 0) {
      message.error("Please add at least one dropdown option");
      return;
    }
    const payload = {
      course_name: formValues.course_name,
      type: formValues.type,
      mandatory: formValues.mandatory === "yes" ? true : false,
      visible_on_report: formValues.visible_on_report === "yes" ? true : false,
      visible_to_learn: formValues.visible_to_learn === "yes" ? true : false,
      field_options:
        formValues.type === "dropdown"
          ? JSON.stringify(dropdownOptions)
          : null,
      created_at: selectedData.updated_at,
    };
    try {
      const response = await PostUpdateData({
        endPoint: `/settings/updatecourse/${userInfo.clientId}/${selectedData.course_id}`,
        method: "PATCH",
        obj: payload,
      });
      if (response?.status === 200) {
        setModalMessage("Saved");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
          setCourseView("course");
        }, 2000);
        handleGetCourseData();
      } else {
        setModalMessage("Error occurred");
        setIsModalVisible(true);
        setTimeout(() => {
          setIsModalVisible(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error while editing custom field:", error);
      setModalMessage("Error occurred");
      setIsModalVisible(true);
      setTimeout(() => {
        setIsModalVisible(false);
      }, 2000);
    }
  };
  const handleValuesChange = (changedValues, allValues) => {
    console.log("Changed Values: ", changedValues);
    console.log("All Values: ", allValues);
    // Set the form values in state if needed
    setFormValues(allValues);
  };

  // const onFinish = (values) => {
  //   if (isEditing) {
  //     console.log("Edited successfully:", values);
  //   } else {
  //     console.log("Created successfully:", values);
  //   }
  //   setModalVisible(true);
  //   setTimeout(() => {
  //     setModalVisible(false);
  //     setCourseView("course"); // Navigate back to the course view after modal disappears
  //   }, 2000);
  // };

  useEffect(() => {
    if (selectedData) {
      form.setFieldsValue(selectedData);
      setFormValues(selectedData);
      setSelectedType(selectedData.type || "");
      try {
        const parsed = selectedData.field_options
          ? JSON.parse(selectedData.field_options)
          : [];
        setDropdownOptions(Array.isArray(parsed) ? parsed : []);
      } catch (error) {
        setDropdownOptions([]);
      }
    }
  }, [form, selectedData]);

  const handleTypeChange = (value) => {
    setSelectedType(value);
  };

  const handleAddOption = () => {
    const trimmed = newOptionText.trim();
    if (!trimmed || dropdownOptions.includes(trimmed)) {
      setNewOptionText("");
      return;
    }
    setDropdownOptions((prev) => [...prev, trimmed]);
    setNewOptionText("");
  };

  const handleRemoveOption = (option) => {
    setDropdownOptions((prev) => prev.filter((item) => item !== option));
  };

  return (
    <>
      <StyledCoursePage>
        <div>
          <div className="flex text-left gap-3">
            <p onClick={() => setCourseView("course")} className="custom-field">
              Custom Field
            </p>
            <RightOutlined className="h-[24px]" />
            <p className="editing-creating-text">
              {isEditMode ? "Editing Custom Field" : "Creating Custom Field"}
            </p>
          </div>
          <br />
          <Form
            form={form}
            name="custom-form"
            onFinish={
              courseView === "custom-edit" ? handlePatchData : handlePostData
            }
            onValuesChange={handleValuesChange}
            layout="vertical"
          >
            {/* Row 1: Name / Type */}
            <div className="flex justify-between">
              <div className="w-[48%]">
                <Form.Item
                  name="course_name"
                  label={<span className="name-text">Name</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please enter the name",
                    },
                  ]}
                  style={{ textAlign: "left" }}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="w-[48%]">
                <Form.Item
                  name="type"
                  label={<span className="type-text">Type</span>}
                  rules={[{ required: true, message: "Please select a type" }]}
                  style={{ textAlign: "left" }}
                >
                  <Select className="text-left" onChange={handleTypeChange}>
                    <Option value="text">Text</Option>
                    <Option value="dropdown">Dropdown</Option>
                    <Option value="checkbox">Checkbox</Option>
                    <Option value="date">Date</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>

            {selectedType === "dropdown" && (
              <div className="dropdown-options-block" style={{ textAlign: "left" }}>
                <span className="type-text">Dropdown Options</span>
                <div className="dropdown-options-input-row">
                  <Input
                    placeholder="Enter an option and click Add"
                    value={newOptionText}
                    onChange={(e) => setNewOptionText(e.target.value)}
                    onPressEnter={(e) => {
                      e.preventDefault();
                      handleAddOption();
                    }}
                  />
                  <Button onClick={handleAddOption}>Add</Button>
                </div>
                <div className="dropdown-options-container">
                  {dropdownOptions.length === 0 && (
                    <span className="dropdown-options-empty">
                      No options added yet
                    </span>
                  )}
                  {dropdownOptions.map((option) => (
                    <span key={option} className="dropdown-option-tag">
                      {option}
                      <CloseOutlined onClick={() => handleRemoveOption(option)} />
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Row 2: Mandatory / Visible on Report */}
            <div className="flex justify-between">
              <div className="w-[48%]">
                <Form.Item
                  name="mandatory"
                  label={<span className="mandatory-text">Mandatory</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please select a mandatory option",
                    },
                  ]}
                  style={{ textAlign: "left" }}
                >
                  <Select className="text-left">
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item>
              </div>
              <div className="w-[48%]">
                <Form.Item
                  name="visible_on_report"
                  label={
                    <span className="visible-report-text">Visible on Report</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please select visibility option",
                    },
                  ]}
                  style={{ textAlign: "left" }}
                >
                  <Select className="text-left">
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>

            {/* Row 3: Visible to Learner */}
            <div className="flex justify-between">
              <div className="w-[48%]">
                <Form.Item
                  name="visible_to_learn"
                  label={
                    <span className="visible1-text">Visible to Learner</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please select a mandatory option",
                    },
                  ]}
                  style={{ textAlign: "left" }}
                >
                  <Select className="text-left">
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item>
              </div>
              <div className="w-[48%]" />
            </div>

            {/* Bottom Buttons */}
            <div className="button-style">
              <Button className="cancel-button1" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                className="save-create-button"
                type="primary"
                htmlType="submit"
                // onClick={() => form.submit()}
              >
                {isEditMode ? "Save" : "Create"}
              </Button>
            </div>
          </Form>
        </div>
      </StyledCoursePage>
      <Modal
        width={180}
        height={100}
        open={isModalVisible}
        footer={null}
        closable={false}
        centered
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Tick style={{ width: "34px", height: "34px" }} />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            {modalMessage}
          </p>
        </div>
      </Modal>
    </>
  );
};

export default EditCourseField;
